export const BYTES_PER_MB = 1_048_576;

type FileSizeRestriction = {
  restrictFileSize?: boolean;
  maxFileSizeMb?: number | null;
};

export const getMaxFileSizeMb = ({
  restrictFileSize,
  maxFileSizeMb,
}: FileSizeRestriction): number | undefined => {
  if (!restrictFileSize) return undefined;
  if (typeof maxFileSizeMb !== 'number' || !Number.isInteger(maxFileSizeMb)) return undefined;
  if (maxFileSizeMb < 1) return undefined;
  return maxFileSizeMb;
};

export const isFileTooLarge = (file: File, maxFileSizeMb: number | undefined): boolean => {
  return maxFileSizeMb !== undefined && file.size > maxFileSizeMb * BYTES_PER_MB;
};
